export enum AspectRatios {
  '16_9' = '16:9',
  '4_3' = '4:3',
  '1_1' = '1:1',
  '9_16' = '9:16',
  '3_4' = '3:4',
  '21_9' = '21:9',
  '9_21' = '9:21',
  '3_2' = '3:2',
  '2_3' = '2:3',
  '5_4' = '5:4',
  '4_5' = '4:5',
  'ORIGINAL' = 'original',
}
